import React, { memo, forwardRef } from "react";
const SvgAlphabetD = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.27 18.67c0 .373.053.747.16 1.12.12.373.293.707.52 1 .227.293.513.533.86.72.347.187.753.28 1.22.28.44 0 .833-.087 1.18-.26a2.9 2.9 0 00.88-.72c.253-.293.44-.62.56-.98.133-.373.2-.747.2-1.12 0-.373-.067-.747-.2-1.12a2.847 2.847 0 00-.56-1 2.9 2.9 0 00-.88-.72 2.449 2.449 0 00-1.18-.28c-.467 0-.873.093-1.22.28a2.458 2.458 0 00-.86.7c-.227.293-.4.627-.52 1-.107.36-.16.727-.16 1.1zm7.9 3.76c0 .267-.047.487-.14.66-.08.16-.18.287-.3.38a.906.906 0 01-.38.18c-.12.027-.227.04-.32.04s-.207-.013-.34-.04a.915.915 0 01-.36-.18 1.306 1.306 0 01-.32-.38 1.578 1.578 0 01-.12-.66v-.36h-.04c-.333.56-.8.987-1.4 1.28a4.19 4.19 0 01-1.9.44c-.733 0-1.393-.133-1.98-.4a4.875 4.875 0 01-1.48-1.1 5.271 5.271 0 01-.94-1.62 6.162 6.162 0 01-.32-2c0-.707.113-1.367.34-1.98a4.83 4.83 0 01.96-1.6 4.366 4.366 0 011.48-1.06c.573-.267 1.2-.4 1.88-.4.44 0 .833.053 1.18.16.347.093.647.213.9.36.267.147.493.307.68.48.187.173.34.34.46.5h.06V9.55c0-.28.04-.507.12-.68.093-.187.2-.327.32-.42.133-.093.267-.153.4-.18.133-.04.253-.06.36-.06.093 0 .207.02.34.06.147.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68v12.88z"
      />
    </svg>
  );
});
SvgAlphabetD.displayName = "SvgAlphabetD";
const MemoForwardRef = memo(SvgAlphabetD);
export default MemoForwardRef;
